import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Button } from '@uhg-abyss/web/ui/Button';
// import { IconErrorTriangle } from '@uhg-abyss/web/ui/Icon/IconErrorTriangle';
//TODO update styling

const FlexStyle = styled(Flex, {
  padding: '10px 10px 40px 10px',
});
const MessageStyle = styled(Flex.Content, {
  paddingLeft: 8,
});
const StyledModal = styled(Modal, {
  '& > div > button': {
    top: '42px',
    right: '58px',
  },
});
const ModalTitle = styled(Modal.Title, {
  borderBottom: ({ theme }) =>
    `1px solid ${theme.colors.UHC_GRAY_MEDIUM} !important`,
  padding: '40px 40px 20px 40px !important',
});

export const ProviderConfirmationModal = ({ isOpen, onCancel, onContinue }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleOnContinue = (e) => {
    setIsLoading(true);
    onContinue();
  };

  useEffect(() => {
    if (isLoading) {
      setIsLoading(false);
    }
  }, [isOpen]);

  return (
    <StyledModal
      isOpen={isOpen}
      onRequestClose={onCancel}
      width="42%"
      offset="12%"
    >
      <ModalTitle>Are You Sure ?</ModalTitle>
      <Modal.Section>
        <FlexStyle>
          <Flex.Content space-5>
            {/* <IconErrorTriangle color="warning" /> */}
          </Flex.Content>
          <MessageStyle space-95>
            The information displayed on the page will refresh based on a new
            <br /> selection. Are you sure you'd like to proceed?
          </MessageStyle>
        </FlexStyle>
      </Modal.Section>
      <Flex align="center" justify="flex-end">
        <Button
          id="cancel-button"
          role="button"
          variant="outline"
          aria-label="Cancel Saving Provider Selection"
          aria-labelledby="cancel-save-provider-selection"
          onClick={onCancel}
          styles={{
            button: (base) => ({
              ...base,
              margin: '10px 0px 25px 0px',
              paddingLeft: '20px',
              paddingRight: '20px',
            }),
          }}
        >
          Cancel
        </Button>
        <Button
          id="continue-button"
          role="button"
          theme="primary"
          aria-label="Continue Saving Provider Selection"
          aria-labelledby="continue-save-provider-selection"
          onClick={handleOnContinue}
          isLoading={isLoading}
          styles={{
            button: (base) => ({
              ...base,
              margin: '10px 58px 25px 15px',
              paddingLeft: '20px',
              paddingRight: '20px',
            }),
          }}
        >
          Continue
        </Button>
      </Flex>
    </StyledModal>
  );
};

ProviderConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
};
